import { useVariant } from '@unleash/proxy-client-react';
import { useSelector } from 'react-redux';

import type { AppState } from 'types/app';
import { selectUnleashToggle } from 'selectors/features';
import useMartyContext from 'hooks/useMartyContext';

interface UseIsEnrolledInVariantOptions {
  featureFlag: string;
  variantName?: 'treatment' | 'control' | string;
  isZapposOnly?: boolean;
}

export const useIsEnrolledInVariant = ({ featureFlag, variantName = 'treatment', isZapposOnly = true }: UseIsEnrolledInVariantOptions) => {
  useVariant(featureFlag);

  const {
    marketplace: { is6pm }
  } = useMartyContext();
  const isEnrolled = useSelector((state: AppState) => selectUnleashToggle(featureFlag, state))?.variant?.name === variantName;

  if (isZapposOnly && is6pm) {
    return { isEnrolled: false };
  }

  return { isEnrolled };
};
